import { render } from "./PlanPurchaseComponent.vue?vue&type=template&id=564a1f0a&scoped=true&ts=true"
import script from "./PlanPurchaseComponent.vue?vue&type=script&lang=ts"
export * from "./PlanPurchaseComponent.vue?vue&type=script&lang=ts"

import "./PlanPurchaseComponent.vue?vue&type=style&index=0&id=564a1f0a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564a1f0a"]])

export default __exports__